module.exports = __webpack_public_path__ + "img/50_pourcent.59e85d62.png";